export const DEFAULT_GATEWAY_AMOUNTS = {
  cashapp: [
    4.99, 5.99, 6.99, 7.99, 8.99, 9.99, 10.99, 11.99, 12.99, 14.99,
    17.99, 19.99, 24.99, 29.99, 30.99, 39.99, 49.99, 59.99, 99.99,
    124.99, 129.99, 149.99, 199.99, 300, 400, 500,
  ],
  cashapp_via_lt: [],
  applepay: [
    4.99, 5.99, 6.99, 7.99, 8.99, 9.99, 10.99, 11.99, 12.99, 13.99,
    14.99, 17.99, 19.99, 24.99, 29.99, 30.99, 39.99, 49.99, 59.99,
    99.99, 124.99, 129.99, 149.99, 199.99, 249.99, 299.99, 300,
    399.99, 400, 499.99, 500,
  ],
  googlepay: [
    4.99, 5.99, 6.99, 7.99, 8.99, 9.99, 10.99, 11.99, 12.99, 13.99,
    14.99, 17.99, 19.99, 24.99, 29.99, 30.99, 39.99, 49.99, 59.99,
    99.99, 124.99, 129.99, 149.99, 199.99, 249.99, 299.99, 300,
    399.99, 400, 499.99, 500,
  ],
  chime: [20, 25, 30, 40, 50, 60, 100, 125, 150, 200, 300, 400, 500],
  venmo: [
    10, 14.99, 17.99, 19.99, 24.99, 29.99, 30.99, 39.99, 49.99, 59.99,
    99.99, 124.99, 129.99, 149.99, 199.99, 300.99, 400.99, 500.99,
  ],
  crypto: [
    15, 17.99, 19.99, 24.99, 29.99, 30.99, 39.99, 49.99, 59.99,
    99.99, 124.99, 129.99, 149.99, 199.99, 300.99, 400.99, 500.99,
  ],
};

const WHOLE_DOLLAR_HIGH_TIER_METHODS = new Set(['cashapp', 'applepay', 'googlepay']);
const LEGACY_HIGH_TIER_REPLACEMENTS = new Map([
  [300.99, 300],
  [400.99, 400],
  [500.99, 500],
]);

export const normalizeGatewayAmountOptions = (canonicalCode, amounts) => amounts
  .map(value => Number(value))
  .filter(value => Number.isFinite(value) && value > 0)
  .map(value => Math.round(value * 100) / 100)
  .map(value => (
    WHOLE_DOLLAR_HIGH_TIER_METHODS.has(canonicalCode)
      ? LEGACY_HIGH_TIER_REPLACEMENTS.get(value) ?? value
      : value
  ))
  .filter((value, index, options) => (
    options.findIndex(option => Math.abs(option - value) < 0.005) === index
  ))
  .sort((a, b) => a - b);
